import { useEffect } from "preact/hooks";

export default function useCornerMotion() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;

    let frame;
    const updateMotion = () => {
      frame = undefined;
      const viewportCenter = window.innerHeight / 2;

      document.querySelectorAll("[data-scroll-photo], [data-scroll-reveal], .corner-page h1, .corner-page .page-intro, .corner-page .intro").forEach((element) => {
        const rect = element.getBoundingClientRect();
        const elementCenter = rect.top + rect.height / 2;
        const proximity = Math.max(0, 1 - Math.abs(elementCenter - viewportCenter) / (window.innerHeight * 0.85));

        if (element.hasAttribute("data-scroll-photo")) {
          element.style.setProperty("--scroll-photo-scale", (0.97 + proximity * 0.06).toFixed(3));
        }
        if (element.hasAttribute("data-scroll-reveal")) {
          element.style.setProperty("--scroll-reveal-opacity", (0.72 + proximity * 0.28).toFixed(3));
          element.style.setProperty("--scroll-reveal-scale", (0.985 + proximity * 0.015).toFixed(3));
        }
        if (element.matches("h1, .page-intro, .intro")) {
          const isIntro = element.matches(".page-intro, .intro");
          const isHomeHero = Boolean(element.closest(".home-page"));
          const useHomeIntroBlockMotion = isHomeHero && isIntro;
          if (!element.dataset.motionBaseFontSize) {
            element.dataset.motionBaseFontSize = window.getComputedStyle(element).fontSize;
          }
          const baseFontSize = parseFloat(element.dataset.motionBaseFontSize);
          const textScale = useHomeIntroBlockMotion
            ? 0.95 + proximity * 0.12
            : (isHomeHero ? 0.97 + proximity * 0.06 : (isIntro ? 0.82 + proximity * 0.3 : 0.9 + proximity * 0.16));
          element.style.fontSize = `${Math.round(baseFontSize * textScale * 100) / 100}px`;
          const blockScale = 0.985 + proximity * 0.015;
          const opacity = useHomeIntroBlockMotion ? 0.7 + proximity * 0.3 : (isIntro ? 0.4 + proximity * 0.6 : 0.48 + proximity * 0.52);
          element.style.setProperty("--scroll-hero-opacity", opacity.toFixed(3));
          element.style.setProperty("--scroll-hero-scale", blockScale.toFixed(3));
          const movement = useHomeIntroBlockMotion ? -10 : (isHomeHero ? -10 : (isIntro ? -26 : -30));
          element.style.setProperty("--scroll-hero-y", `${Math.round((1 - proximity) * movement)}px`);
        }
      });
    };

    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(updateMotion);
    };
    const onResize = () => onScroll();

    updateMotion();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);
}
